import { render, staticRenderFns } from "./IventorySettings.vue?vue&type=template&id=24b46863&scoped=true&"
import script from "./IventorySettings.vue?vue&type=script&lang=js&"
export * from "./IventorySettings.vue?vue&type=script&lang=js&"
import style0 from "./IventorySettings.vue?vue&type=style&index=0&id=24b46863&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b46863",
  null
  
)

export default component.exports